import { Avatar, Flex, Regular } from '@zazume/zzm-base';
import { FC } from 'react';

interface Props {
}

export const BasicUserFieldSkeleton: FC<Props> = () => {
  return <>
    <Flex gap="s2" align="center">
      <Avatar.Skeleton variant="M"/>
      <Regular.Skeleton width={12}/>
    </Flex>
  </>;
};
